window.Centrifuge = require("centrifuge");
const websocketUrl = document.querySelector('meta[name="websocket-url"]');

const eventList = {
    'hikvision.alert': ({ type }) => {
        Livewire.emit('alertAdded', type);
    },
    'passes.create': ({ data }) => {
        if (data.hasOwnProperty('is_verified') && !data.is_verified) {
            Livewire.emit('addedRequestPermission', data);
        }
    },
    'chatMessage.create': () => {
        Livewire.emit('chatMessageAdded');
    },
}

if (websocketUrl && websocketUrl.content) {
    const centrifuge = new Centrifuge(websocketUrl.content);

    centrifuge.subscribe('public', function({ data }) {
        if (data.hasOwnProperty('event') && eventList.hasOwnProperty(data.event)) {
            eventList[data.event](data)
        }
    });

    centrifuge.connect();
}
